import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';
import { useConsoleAccess } from '@/shared/auth/useScopes.js';
import { PageSpinner } from '@/shared/auth/SessionGate.jsx';
import { Console } from '@/modules/console/index.jsx';

// /console: docs' console, for whoever administers docs — docs-api's
// `can_manage` (`GET /api/v1/auth/me`: `docs:admin`, the admin persona, or the
// break-glass admin, as its `get_admin_user` decides). Anyone else gets a
// plain refusal, never the tabs (every call would be 403).
export function ConsoleRoute() {
  const { t } = useTranslation('common');
  const access = useConsoleAccess();
  if (!access.ready) return <PageSpinner />;
  if (!access.open) {
    return (
      <div className="h-full flex flex-col items-center justify-center gap-3 p-6 text-center" role="alert">
        <ShieldAlert className="w-8 h-8 text-muted-foreground" />
        <p className="text-sm text-muted-foreground max-w-md">{t('common:console.noAccess')}</p>
      </div>
    );
  }
  return (
    <div className="w-full px-4 sm:px-6 py-6">
      <Console />
    </div>
  );
}

export default ConsoleRoute;
